import GedcomX from '../../shared/helpers/gedcom_X'
import handleReducerSimpleSetter from '../../shared/helpers/handleReducerSimpleSetter'
import getReducerHandler from '../../shared/helpers/getReducerHandler'

const ACTIONS = Object.freeze({
  TREE_INIT_STATE: 'TREE_INIT_STATE',
  EDIT_ANCESTOR: 'EDIT_ANCESTOR',
  COMMIT_ANCESTOR: 'COMMIT_ANCESTOR',
  STATE_UPDATE: 'STATE_UPDATE',
})

const gcx = GedcomX()

const defaultAncestorData = {
  personId: null,
  name: null,
  surname: null,
  displayName: '',
  atn: null,
  dob: null,
  pob: null,
  pobId: null,
  dod: null,
  pod: null,
  podId: null,
  genderType: '',
  living: true,
  portraitThumbnailLink: '',
  lifespan: null,
}

const treeInitialState = {
  // These we will show until the tree info is retrieved from the back end.
  userTree: {
    1: { ...defaultAncestorData, atn: 1, genderType: gcx.MALE },
    2: { ...defaultAncestorData, atn: 2, genderType: gcx.MALE },
    3: { ...defaultAncestorData, atn: 3, genderType: gcx.FEMALE },
    4: { ...defaultAncestorData, atn: 4, genderType: gcx.MALE },
    5: { ...defaultAncestorData, atn: 5, genderType: gcx.FEMALE },
    6: { ...defaultAncestorData, atn: 6, genderType: gcx.MALE },
    7: { ...defaultAncestorData, atn: 7, genderType: gcx.FEMALE },
  },
  includeLocation: true,
  anchorATN: 2,
}

/*
 * --- INDIVIDUAL ACTION HANDLERS ---
 * (Set multiple values & merge/processing logic only, otherwise use handleReducerSimpleSetter)
 */

const handleCommitAncestor = (state, action) => {
  const person = action.payload.person || {}
  const atn = person.atn
  if (atn == null) return state
  const existing = state.userTree[atn] || {}
  const updated = { ...existing, ...person }
  return {
    ...state,
    userTree: { ...state.userTree, [atn]: updated },
  }
}

// --- Handlers registry ---
const handlers = {
  [ACTIONS.TREE_INIT_STATE]: handleReducerSimpleSetter,
  [ACTIONS.EDIT_ANCESTOR]: handleReducerSimpleSetter,
  [ACTIONS.COMMIT_ANCESTOR]: handleCommitAncestor,
  [ACTIONS.STATE_UPDATE]: handleReducerSimpleSetter,
}

const treeReducer = (state, action) => getReducerHandler(state, action, handlers)

export { treeInitialState, treeReducer, ACTIONS }
